export const career = {
	seo: {
		title: 'University Career Guides',
		description:
			'Browse our range of university career guides at Uni Compare. Learn about potential careers & get advice on career development.',
	},
	header: {
		title: 'Career Job Profiles',
		description:
			'Learn more about your dream career with our career guides. These guides give you a detailed breakdown of everything you need to know.',
		backgroundStyle: 'bg-career-guides',
	},
	main: {
		title: 'Learn about your future career',
		description:
			"Uni Compare's career guides are here to help you take the next steps in your university journey. A university degree can have a huge impact on the career you choose, so with this in mind, we've created our career guides to arm you with the knowledge you need to choose the career you want. In our guides, you will see a detailed breakdown of what the job is, what qualifications you need, the skills required, the responsibilities of the role, salary expectations and working hours. Our career guides give you a unique insight into the working world and show you what is required from you as a student to pick the career of your dreams! Explore over 80 in-depth career guides and take the next step towards your future.",
	},
	title: 'A to Z of Career Guides',
};

export const city = {
	seo: {
		title: 'University City Guides',
		description:
			'Browse our range of university city guides at Uni Compare, for all the major cities in the UK. Find out about your future home today!',
	},
	header: {
		title: 'Find your future home by exploring our university city guides',
		description:
			"Learn about your new student home with our university city guides. We've taken the time break the most popular student cities in the UK university.",
		backgroundStyle: 'bg-city-guides',
	},
	main: {
		title: 'Discover your next student city',
		description:
			"Our university guides are here to give you an insight into what life is like in the city you're hoping to call home. Our city guides offer you a fresh and unique perspective on what the average student is looking for. Here, we will have the history of the city, the different things to do, what the local transport links are like and we’ll show you the universities in the city and the local sport. Many students make their decisions on the university they want to attend based on the area it is in, with our city guides, you will be able to make an informed decision on your next steps with peace of mind!",
	},
	title: 'A to Z of City Guides',
};

export const subject = {
	seo: {
		title: 'University Subject Guides',
		description:
			'Browse our range of university subject guides at Uni Compare. We&#39;ve got all the information you need for any subject and degree!',
	},
	header: {
		title: 'Find the right course by exploring our subject degree guides',
		description:
			'Read our bite-sized guides as a perfect introduction in to what you will be studying when on your selected course at university.',
		backgroundStyle: 'bg-subject-guides',
	},
	main: {
		title: 'Subject Degree Guides',
		description:
			'Our subject degree guides are here to help you discover which university course suits you. These guides will teach you about two the degree is structured, what kind of course load you can expect, whether there are examinations and what jobs are best suited to you when the course is finished. These guides also feature detailed breakdowns of the entry requirements for every course and how best to go about applying for them. Another important aspect to consider with any degree course that you study, is what happens after you graduate. We take an in-depth look at what career prospects are like for students after they finish their degree; you can see what kind of salary you can hope to pull down, which recruitment companies specialise in this area and what kind of career progression you can expect with your degree.',
	},
	title: 'A to Z of Subject Degree Guides',
};
